export default "__VITE_ASSET__wuDZQ4NL__"